import BaseThemeAutopayManager from 'frontend/theme/components/AutopayManager'

// Extend from the AutopayManager theming in the base theme.
const baseThemeStyle = BaseThemeAutopayManager.baseStyle


const baseStyle = {
    ...baseThemeStyle,
    paymentMethod: {
        ...baseThemeStyle.paymentMethod,
        bgColor: "cardBackground.500",
    },
    makeDefaultButton: {
        ...baseThemeStyle.makeDefaultButton,
        variant: "secondary"
    },
    removeButton: {
        ...baseThemeStyle.removeButton,
        variant: "secondaryNo"
    },
}

export default {
    ...BaseThemeAutopayManager,
    baseStyle,
};
